export default "__VITE_ASSET__CdzZxYz2__ 288w, __VITE_ASSET___dVJOExT__ 432w, __VITE_ASSET__CkSabZF8__ 576w";